// Copyright (c) 2016 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import LabeledString from '../../../../shared/components/labeled-string';
import LatestPerUnitMeasurements from '../../../../shared/components/latest-per-unit-measurements';
import {Link} from 'react-router';
import MeasurementReading from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';
import PipIndicator from '@deere/cps-it.warranty-model-factory/lib/pip-indicator';
import PipStatus from '../../../../product/shared/components/pip-status';
import ProductImage from './../../../../shared/components/product-image';
import WarrantyLink from '../warranty-link';
import {buildDate} from '../../../../shared/services/build-date';

const ProductClaimsPanel = props =>
    <section className='product-panel'>
        <header className='product-panel-title'>
            <Link
                rel='noopener noreferrer'
                target='_blank'
                to={`/products/${props.pin}`}
            >
                {props.pin}
            </Link>
        </header>
        {props.pin ?
            <main>
                <div className='product-details'>
                    <div className='product-image'>
                        <ProductImage
                            imageURL={props.imageUrl}
                            placeHolderText={props.baseMachineCode}
                        />
                    </div>
                    <div className='product-pin-details'>
                        <LabeledString
                            className='model'
                            data={props.modelNumber}
                            label='MODEL'
                        />
                        {props.pipIndicator.status &&
                            <PipStatus
                                openInNewTab={true}
                                pin={props.pin}
                                pipIndicator={props.pipIndicator}
                            />
                        }
                        <WarrantyLink
                            handleWarrantyLink={props.handleWarrantyLink}
                        />
                    </div>
                </div>
                <LatestPerUnitMeasurements
                    latestPerUnitMeasurements={props.latestPerUnitMeasurements}
                />
                <LabeledString
                    className='build-date'
                    data={buildDate(props.buildDate)}
                    label='BUILT'
                />
            </main> :
            <FormattedMessage id='NO_PRODUCT_FOUND'/>
        }
    </section>;

ProductClaimsPanel.displayName = 'ProductClaimsPanel';
ProductClaimsPanel.propTypes = {
    baseMachineCode: PropTypes.string.isRequired,
    buildDate: PropTypes.number.isRequired,
    handleWarrantyLink: PropTypes.func.isRequired,
    imageUrl: PropTypes.string.isRequired,
    latestPerUnitMeasurements: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired,
    modelNumber: PropTypes.string.isRequired,
    pin: PropTypes.string.isRequired,
    pipIndicator: PropTypes.instanceOf(PipIndicator).isRequired

};

export default ProductClaimsPanel;



// WEBPACK FOOTER //
// ./src/claim/shared/components/product-panel/index.js